import { createRouter, createWebHistory } from 'vue-router'
import { isAdminLoggedIn } from '../utils/adminAuth'
import { applyRouteSeo } from '../utils/applyRouteSeo'

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: () => import('../views/MainContent.vue')
  // },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import('../views/home.vue')
  // },
  // {
  //   path: '/home1',
  //   name: 'home1',
  //   component: () => import('../views/home1.vue')
  // },
  {
    path: '/',
    name: 'home2',
    component: () => import('../views/home2.vue')
  },
  {
    path: '/directorsOfficers',
    name: 'directorsOfficers',
    component: () => import('../views/directorsOfficers .vue')
  },
  {
    path: '/globalClients',
    name: 'globalClients',
    component: () => import('../views/globalClients.vue')
  },
  {
    path: '/privateEquity',
    name: 'privateEquity',
    component: () => import('../views/privateEquity.vue')
  }, {
    path: '/foodBeverage',
    name: 'foodBeverage',
    component: () => import('../views/foodBeverage.vue')
  }, {
    path: '/manufacturingTechnology',
    name: 'manufacturingTechnology',
    component: () => import('../views/manufacturingTechnology.vue')
  }, {
    path: '/sportsEntertainmentEvents',
    name: 'sportsEntertainmentEvents',
    component: () => import('../views/sportsEntertainmentEvents.vue')
  }
  , {
    path: '/automotiveInfrastructure',
    name: 'automotiveInfrastructure',
    component: () => import('../views/automotiveInfrastructure.vue')
  }
  , {
    path: '/realEstateConstructions',
    name: 'realEstateConstructions',
    component: () => import('../views/realEstateConstructions.vue')
  }
  , {
    path: '/lifeScience',
    name: 'lifeScience',
    component: () => import('../views/lifeScience.vue')
  }
  , {
    path: '/financialInstitutions',
    name: 'financialInstitutions',
    component: () => import('../views/financialInstitutions.vue')
  }
  , {
    path: '/energyPower',
    name: 'energyPower',
    component: () => import('../views/energyPower.vue')
  }
  , {
    path: '/mergersAcquisitions',
    name: 'mergersAcquisitions',
    component: () => import('../views/mergersAcquisitions.vue')
  }
  , {
    path: '/propertyCasualty',
    name: 'propertyCasualty',
    component: () => import('../views/propertyCasualty.vue')
  }
  , {
    path: '/cyberSecurity',
    name: 'cyberSecurity',
    component: () => import('../views/cyberSecurity.vue')
  }
  , {
    path: '/employeeBenefits',
    name: 'employeeBenefits',
    component: () => import('../views/employeeBenefits.vue')
  }
  ,   {
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue')
  },
  {
    path: '/companyFacts',
    name: 'companyFacts',
    component: () => import('../views/companyFacts.vue')
  }, {
    path: '/student',
    name: 'student',
    component: () => import('../views/student.vue')
  }, {
    path: '/business',
    name: 'business',
    component: () => import('../views/business.vue')
  }, {
    path: '/residence',
    name: 'residence',
    component: () => import('../views/residence.vue')
  }
  , {
    path: '/Individuals',
    name: 'Individuals',
    component: () => import('../views/Individuals.vue')
  }
  , {
    path: '/news',
    name: 'news',
    component: () => import('../views/news.vue')
  }
  , {
    path: '/personal',
    name: 'personal',
    component: () => import('../views/personal.vue')
  },
  {
    path: '/highEnd',
    name: 'highEnd',
    component: () => import('../views/highEnd.vue')
  },
  {
    path: '/children',
    name: 'children',
    component: () => import('../views/children.vue')
  },
  {
    path: '/elderly',
    name: 'elderly',
    component: () => import('../views/elderly.vue')
  },
  {
    path: '/life',
    name: 'life',
    component: () => import('../views/life.vue')
  },
  {
    path: '/travel',
    name: 'travel',
    component: () => import('../views/travel.vue')
  }
  ,
  {
    path: '/seeall',
    name: 'seeall',
    component: () => import('../views/seeall.vue')
  },
  {
    path: '/contact-success',
    name: 'contactSuccess',
    component: () => import('../views/ContactSuccess.vue')
  },
  {
    path: '/admin/login',
    name: 'adminLogin',
    component: () => import('../views/AdminLogin.vue')
  },
  {
    path: '/admin/news',
    name: 'adminNewsList',
    component: () => import('../views/AdminNewsList.vue')
  },
  {
    path: '/admin/news/create',
    name: 'adminNewsCreate',
    component: () => import('../views/AdminNewsEditor.vue')
  },
  {
    path: '/admin/news/:id/edit',
    name: 'adminNewsEdit',
    component: () => import('../views/AdminNewsEditor.vue'),
    props: true
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }

})

router.afterEach((to) => {
  applyRouteSeo(to)
})

router.beforeEach((to, from, next) => {
  if (!to.path.startsWith('/admin')) {
    next()
    return
  }

  const loggedIn = isAdminLoggedIn()

  if (to.path === '/admin/login') {
    next(loggedIn ? '/admin/news' : true)
    return
  }

  next(loggedIn ? true : '/admin/login')
})

export default router
